import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import TooltipProps from './TooltipProps'

import Animation from '../Common/Animation'
import Content from './Content'

export default {
    props: TooltipProps,
    render (h) {
        return h('div',this.$slots.default)
    },
    mixins: [
        KendoBaseComponent,
        Animation,
        Content
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoTooltip(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTooltip()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoTooltip/KendoTooltipMixin.js